import { Button, Checkbox, Group, Paper, Stack } from '@mantine/core';
import { UseMutationResult, UseQueryResult } from '@tanstack/react-query';
import { FC, RefObject } from 'react';
import { useTranslation } from 'react-i18next';

import { FarmerLayout } from '../../../components/farmer-layout/farmer-layout';
import { PDFViewer } from '../../../components/pdf-viewer';
import { ValidationInfoResponse } from '../../../lib/types/validation';

const API_ROOT = import.meta.env.VITE_API_ROOT;

interface ConsentStepProps {
  consentChecked: boolean;
  containerRef: RefObject<HTMLDivElement>;
  containerWidth: number;
  info: UseQueryResult<ValidationInfoResponse>;
  onConsentCheckedChange: (checked: boolean) => void;
  signConsent: UseMutationResult<unknown, Error, string, unknown>;
  token: string;
}

export const ConsentStep: FC<ConsentStepProps> = ({
  consentChecked,
  containerRef,
  containerWidth,
  info,
  onConsentCheckedChange,
  signConsent,
  token,
}) => {
  const { t } = useTranslation();

  return (
    <FarmerLayout>
      <Stack gap="md" style={{ flex: 1, minHeight: 0 }}>
        <Paper
          p={0}
          ref={containerRef}
          style={{
            flex: 1,
            overflow: 'auto',
            display: 'flex',
            justifyContent: 'center',
            maxWidth: '100%',
          }}
        >
          {info.data?.consent_form?.file ? (
            <PDFViewer
              file={`${API_ROOT}${info.data.consent_form.file}`}
              width={containerWidth ? Math.min(containerWidth, 800) : 800}
            />
          ) : null}
        </Paper>
        <Group justify="end">
          <Stack>
            <Checkbox
              checked={consentChecked}
              label={t('farmer-consent.sign')}
              onChange={(event) =>
                onConsentCheckedChange(event.currentTarget.checked)
              }
            />
            <Button
              disabled={!consentChecked}
              loading={signConsent.isPending}
              onClick={() => {
                if (consentChecked) {
                  signConsent.mutate(token);
                }
              }}
              size="md"
            >
              {t('farmer-consent.confirmcta')}
            </Button>
          </Stack>
        </Group>
      </Stack>
    </FarmerLayout>
  );
};
